
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import ReactHtml from 'raw-html-react';
class Footer1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menu : []
            

        }
    }; 
    componentDidMount(){
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Homepage Section/Main Footer'), {
            headers : {'Authorization' : process.env.REACT_APP_TOKEN, 
        'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({menu:response.data['data']})
        //console.log(response.data['data'])
        })
    }
    render() {
         return <div>

<div class="footer-top section pt-100 pt-lg-80 pt-md-70 pt-sm-60 pt-xs-50 pb-55 pb-lg-35 pb-md-25 pb-sm-15 pb-xs-10">
        <div class="container">
        <ReactHtml html={this.state.menu['section_html']}/>
        </div>
    </div>
    </div>
      }
    }
    export default Footer1;